import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../services/auth.service';
import '../styles/SignInPage.css';
import { getErrorMessage } from '../utils/error';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.forgotPassword(email);
      setSubmitted(true);
    } catch (err) {
      setError(getErrorMessage(err, 'Une erreur est survenue.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signin-container">
      <div className="signin-card">
        <h1 className="signin-title">Coloc App</h1>
        <h2 className="signin-subtitle">Mot de passe oublié</h2>

        {submitted ? (
          <div>
            <p style={{ color: '#27ae60', marginBottom: '1rem' }}>
              Si un compte existe avec cette adresse email, un lien de réinitialisation a été envoyé.
            </p>
            <div className="signin-links">
              <Link to="/signin" className="forgot-password-link">
                Retour à la connexion
              </Link>
            </div>
          </div>
        ) : (
          <>
            {error && <div className="signin-error">{error}</div>}

            <form onSubmit={handleSubmit} className="signin-form">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  autoComplete="email"
                  inputMode="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="form-control"
                  placeholder="Entrez votre email"
                />
              </div>

              <button
                type="submit"
                className="signin-button"
                disabled={loading}
              >
                {loading ? 'Envoi en cours...' : 'Envoyer le lien'}
              </button>
            </form>

            <div className="signin-links">
              <Link to="/signin" className="forgot-password-link">
                Retour à la connexion
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
